import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';

// Service & Constants
import { ROLES } from 'services/constants';
// import { openUrlSchemes } from 'services/functions';

// Patient
// import CancelAppointment from 'views/patient/CancelAppointment/CancelAppointment';
// import Dashboard from 'views/patient/Dashboard';
// import Login from 'views/patient/Login';
// import Profile from 'views/patient/Profile';
// import Reservation from 'views/patient/Reservation';
// import Rescheduling from 'views/patient/Rescheduling/Rescheduling';
// import SignUp from 'views/patient/SignUp';
// import SendRestoreEmail from 'views/patient/RestoreAccess/SendRestoreEmail/SendRestoreEmail';
// import ResetPassword from 'views/patient/RestoreAccess/ResetPassword/ResetPassword';

// Practitioner
import Appointment from './views/practitioner/Appointment';
import Appointments from './views/practitioner/Appointments/Appointments';
import PractitionerLogin from './views/practitioner/Login';
import CreateInvoice from './views/practitioner/CreateInvoice';
import Reporting from './views/practitioner/Reporting';
import VideoConsultation from './views/practitioner/VideoConsultation/VideoConsultation';
import Jobs from './views/practitioner/Jobs/Jobs';
import CreateNewJob from './views/practitioner/CreateNewJob/CreateNewJob';

// Components
import App from './App';
import PreLoader from 'components/PreLoader';
import authHOC from './views/practitioner/components/AuthHOC';
import NotFoundPage from 'components/404';
import RedirectToV2Page from './views/static/RedirectToV2Page';

// Store
import store, { history } from './store/createStore';

// localization
import { I18nextProvider } from 'react-i18next';
import i18next from './i18n';

// const OpenInitScreenWithUrlScheme = () => (
//   <div>
//     {openUrlSchemes()}
//     <Redirect to="/" />
//   </div>
// );

export default () => (
  <div className="app-wrapper">
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18next}>
          <App>
            <Switch>
              {/* ──── Practitioner ────────────────────────────────────────────────────────── */}
              <Route
                exact
                path="/practitioner"
                render={() => {
                  const role = localStorage.getItem('um_role');
                  const token = localStorage.getItem('token');
                  return (role === ROLES.STAFF || role === ROLES.PRACTITIONER || role === ROLES.RADIOLOGY) && token ? (
                    <Redirect to="/practitioner/appointments/today" />
                  ) : (
                    <PractitionerLogin />
                  );
                }}
              />
              <Route exact path="/practitioner/appointments/:screenType" component={authHOC(Appointments)} />
              <Route
                path="/practitioner/appointments/:appointmentId/appointment/video"
                component={authHOC(VideoConsultation)}
              />
              <Route path="/practitioner/appointments/:appointmentId/appointment" component={authHOC(Appointment)} />
              <Route
                path="/practitioner/appointments/:appointmentId/create-invoice/:invoiceId?"
                component={authHOC(CreateInvoice)}
              />
              <Route path="/practitioner/reporting" component={authHOC(Reporting)} />
              <Route path="/practitioner/jobs" component={authHOC(Jobs)} />
              <Route path="/practitioner/new-job" component={authHOC(CreateNewJob)} />

              {/* ──── Patient ───────────────────────────────────────────────────────────── */}
              {/* <Route
                exact
                path="/"
                render={() => {
                  const role = localStorage.getItem('um_role');
                  const token = localStorage.getItem('token');
                  return role === ROLES.PATIENT && token ? <Redirect to="/dashboard/overview" /> : <Login />;
                }}
              />
              <Route path="/dashboard" component={Dashboard} />
              <Route
                path="/cancel-appointment"
                render={() => (
                  <div>
                    {openUrlSchemes()}
                    <CancelAppointment />
                  </div>
                )}
              />
              <Route path="/profile" component={Profile} />
              <Route path="/registration" component={SignUp} />
              <Route exact path="/reservation" component={Reservation} />
              <Route path="/rescheduling" component={Rescheduling} />
              <Route path="/restore-access" component={SendRestoreEmail} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/password-was-changed" render={OpenInitScreenWithUrlScheme} />
              <Route path="/password-was-changed-failed" render={OpenInitScreenWithUrlScheme} />
              <Route path="/payment-results" render={OpenInitScreenWithUrlScheme} /> */}

              <Route exact path="/" render={RedirectToV2Page} />
              <Route exact path="/reservation" component={RedirectToV2Page} />

              <Route component={NotFoundPage} />
            </Switch>

            <PreLoader />
          </App>
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>
  </div>
);
